const achievementData = [
    {
        award: "First Prize in PoC & Ideathon",
        issuer: "Department of AI, Kongu Engineering College",
        issuedon: "December & October, 2022",
    },
    {
        award: "Third Prize in Project Expo",
        issuer: "TBI Kongu Engineering College",
        issuedon: "February, 2024",
    },
    {
        award: "Overall Best Cadet in CATC 2 Cum IGC Camp",
        issuer: "TN, P & AN DTE",
        issuedon: "April, 2024",
    },
    {
        award: "Appreciation Award (Best in Training & Social Service)",
        issuer: "TN, P & AN DTE",
        issuedon: "April, 2024",
    },
    {
        award: "Silver Medal in NIAP Program @ EBSB Camp 2025",
        issuer: "TN, P & AN DTE",
        issuedon: "January, 2025",
    },
    {
        award: "Academic Excellence Awards",
        issuer: "KVIT Trust",
        issuedon: "2025, 2024, 2023",
    },
    {
        award: "Best Outgoing Cadet",
        issuer: "Kongu Engineering College",
        issuedon: "March, 2025",
    },
    {
        award: "Best Student in Academic Activities",
        issuer: "Kongu Engineering College",
        issuedon: "March, 2025",
    },
    {
        award: "Best Outgoing Student",
        issuer: "Kongu Engineering College",
        issuedon: "March, 2025",
    },
]

export default achievementData;